// extracted by mini-css-extract-plugin
export var body = "_nb-8";
export var button = "_nb-0";
export var closeButton = "_nb-5";
export var content = "_nb-3";
export var empty = "_nb-f";
export var grid = "_nb-c";
export var header = "_nb-4";
export var icon = "_nb-1";
export var option = "_nb-d";
export var optionSelected = "_nb-e";
export var overlay = "_nb-2";
export var searchIcon = "_nb-a";
export var searchInput = "_nb-b";
export var searchWrapper = "_nb-9";
export var title = "_nb-6";
export var visuallyHidden = "_nb-7";